
export enum PickupShipmentSourceCd {
	EDI = 'EDI',
	MANUAL = 'Manual',
	WEB = 'Web'}
